module.exports = __webpack_public_path__ + "img/send-clock.d0d3a93b.svg";